import { render, staticRenderFns } from "./totalData.vue?vue&type=template&id=7ac397b8&scoped=true&"
import script from "./totalData.vue?vue&type=script&lang=js&"
export * from "./totalData.vue?vue&type=script&lang=js&"
import style0 from "./totalData.vue?vue&type=style&index=0&id=7ac397b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac397b8",
  null
  
)

export default component.exports